module.exports = "/images/fr.svg";